/**
 * @deprecated This export is considered deprecated and will be removed in v4.
 * To learn how to migrate visit: https://chameleondesignsystem.com/resources/migrations/core-v3/
 * */
export var Orientation;
(function (Orientation) {
    Orientation["horizontal"] = "horizontal";
    Orientation["vertical"] = "vertical";
})(Orientation || (Orientation = {}));
